/**
 * Winwin — forgot password bridge
 */
(function () {
  async function init(root) {
    var form = root.querySelector('[data-forgot-form]');
    if (!form || !window.WinwinApi) return;
    var apiBase = window.WinwinApi.baseFrom(root);
    var errorBox = root.querySelector('[data-forgot-errors]');
    var successBox = root.querySelector('[data-forgot-success]');
    var submitBtn = form.querySelector('[type="submit"]');

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
      if (successBox) successBox.hidden = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.label = submitBtn.dataset.label || submitBtn.textContent;
        submitBtn.textContent = 'Sending…';
      }
      var email = String(new FormData(form).get('email') || '').trim();
      try {
        var res = await window.WinwinApi.request(apiBase, '/forgot-password', {
          method: 'POST',
          body: { email: email }
        });
        if (!res.ok || !res.data || res.data.success !== true) {
          if (errorBox) {
            errorBox.hidden = false;
            errorBox.textContent = (res.data && res.data.errors && res.data.errors[0] && res.data.errors[0].text)
              || 'Could not send reset email.';
          }
          return;
        }
        form.hidden = true;
        if (successBox) {
          successBox.hidden = false;
          var msg = successBox.querySelector('[data-forgot-success-text]');
          if (msg && res.data.message) msg.textContent = res.data.message;
        }
      } catch (err) {
        console.error('[winwin forgot]', err);
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = 'Network error. Please try again.';
        }
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.label || 'Send reset link';
        }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-forgot-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
